import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper('.pricing-swiper-init', {
  loop: false,
  slidesPerView: 1.01,
  spaceBetween: 15,
  centeredSlides: false,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 20,
   navigation: {
        nextEl: '.right-arrow-btn',
        prevEl: '.left-arrow-btn',
      },


  breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 30,
    },
    // десктоп і більше
    1440: {
      slidesPerView: 4,
      slidesPerGroup: 3,
      spaceBetween: 24,
    },
  },
});

document
  .querySelectorAll('.left-arrow-btn, .right-arrow-btn')
  .forEach(btn => {
    btn.addEventListener('click', () => {
      btn.blur();
    });
  });